import {Repository, createRepository} from '@/repositories/Base/Repository'

class ReviewObservationRepository extends Repository {
    endpoint = 'integration/review_observation'

    listAll(params) {
        return this.$axios.get(`${this.endpoint}`, {params})
    }

    listOne(id) {
        return this.$axios.get(`${this.endpoint}/edit/${id}`)
    }

    listNext() {
        return this.$axios.get(`${this.endpoint}/next`)
    }

    cancel(id) {
        return this.$axios.put(`${this.endpoint}/cancel/${id}`)
    }
}

export default new ReviewObservationRepository()

export const create = createRepository(ReviewObservationRepository)
